<template>
  <b-card>
    <div class="row">
      <div class="col-6 d-flex align-items-center justify-content-lg-start">
        <Button
          v-if="showBackButton"
          label="List page"
          size="md"
          icon="ArrowLeftIcon"
          show-icon
          class="mb-1"
          @click="backNavigationAction"
        />
      </div>
      <div class="col-6 d-flex justify-content-end">
        <Button
          v-if="showSearchButton"
          label="Search"
          size="md"
          icon="SearchIcon"
          show-icon
          @click="showSearchField"
        />
      </div>
    </div>
    <b-row class="position-relative">
      <b-col
        v-if="!showSearchButton"
        md="4"
      >
        <b-row>
          <Alert
            :show="showFormErrorAlert"
            message=" Customer's account name or account number or customer id is required"
          />

          <b-col md="12">
            <InputField
              id="account-number"
              v-model="searchParams.accountNumber"
              label="Account Number"
              placeholder="Enter account number"
              type="number"
            />
          </b-col>

          <b-col md="12">
            <InputField
              id="account-name"
              v-model="searchParams.accountName"
              label="Account Name"
              placeholder="Enter account name"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="reference-number"
              v-model="searchParams.referenceNumber"
              label="Reference Number"
              placeholder="Enter reference number"
              type="text"
            />
          </b-col>

          <b-col md="12">
            <Button
              label="Search"
              size="md"
              class="mt-2"
              block
              @click="handleSearch"
            />
          </b-col>
        </b-row>

      </b-col>
      <b-col
        v-if="showSearchButton"
        :md="showSearchButton === true ? '12' : '8'"
      >
        <div v-if="showCustomerInfo">
          <validation-observer ref="cashWithdrawalRules">
            <app-collapse
              class="business-items mb-4"
              type="margin"
              accordion
            >
              <app-collapse-item
                title="Account Summary"
                class="card-item"
                is-visible
              >
                <b-row>
                  <b-col md="3">
                    <InputField
                      id="account-name"
                      v-model="customer.accountName"
                      label="Account Name"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">

                    <InputField
                      id="account-number"
                      v-model="depositData.accountNumber"
                      label="Account Number"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="product-name"
                      v-model="customer.productName"
                      label="Product Name"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="nuban"
                      v-model="customer.accountNumber"
                      label="NUBAN"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="branch"
                      v-model="customer.branchName"
                      label="Branch"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="account-status"
                      v-model="customer.accountStatus"
                      label="Account Status"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="ledger-balance"
                      v-model="customer.ledgerBalance"
                      label="Ledger Balance"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="available-balance"
                      v-model="customer.availableBalance"
                      label="Available Balance"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="withdrawable-balance"
                      v-model="customer.withdrawableBalance"
                      label="Withdrawable Balance"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="overdraft-limit"
                      v-model="customer.overdraftLimit"
                      label="Overdraft Limit"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="account-officer"
                      v-model="customer.accountOfficer"
                      label="Account Officer"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="tier-level"
                      v-model="customer.accountTierLevel"
                      label=" Tier Level"
                      type="number"
                      readonly
                    />
                  </b-col>

                </b-row>

                <!-- <b-row class="mt-2">
                  <b-col
                    cols="12"
                    class="mb-2 mt-2"
                  >
                    <Button
                      label="View Signatory Mandate"
                      size="sm"
                      class="mb-2"
                      @click="onViewSignatoryMandate"
                    />
                  </b-col>
                </b-row> -->
              </app-collapse-item>
            </app-collapse>

            <h5 class="text-capitalize mb-3">
              Posting Details
            </h5>

            <b-row>
              <b-col md="6">
                <InputNumberField
                  id="amount"
                  v-model="depositData.amount"
                  label="Amount"
                  placeholder="Enter amount"
                  error-name="Amount"
                  rules="required|positive"
                />

              </b-col>
              <b-col md="6">
                <InputField
                  id="instrument-no"
                  v-model="depositData.instrumentNumber"
                  label="Instrument No"
                  placeholder="Enter instrument no"
                  type="text"
                  rules="required"
                  error-name="Instrument No"
                  :on-input="setInstrumentNoNarration"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="payee"
                  v-model="postingFormData.postingData.senderName"
                  label="Payee"
                  placeholder="Enter payee"
                  type="text"
                  rules="required"
                  error-name="Payee"
                  :on-input="setPayeeNarration"
                  onpaste="return false;"
                  :is-allow-special-characters="false"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="narration"
                  v-model="depositData.narration"
                  label="Narration"
                  placeholder="Enter narration"
                  type="text"
                  rules="required"
                  error-name="narration"
                />
              </b-col>
            </b-row>
          </validation-observer>
          <div class="text-center mt-5">
            <Button
              label="Continue"
              :loading="isLoading"
              :disabled="isDisabled"
              size="lg"
              @click="onViewSignatoryMandate"
            />
          </div>

        </div>
      </b-col>
    </b-row>

    <b-modal
      id="search-modal"
      ref="my-modal"
      cancel-title="Cancel"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      title="Customer Details"
      cancel-title-only
      @hidden="resetModal"
    >

      <b-table
        ref="customerListTable"
        select-mode="single"
        :items="customerList"
        responsive
        :fields="tableHeaders"
        primary-key="id"
        selectable
        show-empty
        empty-text="No result found"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >

        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <b-modal
      id="signatory-mandate-table"
      ref="signatoryMandateTable"
      no-close-on-backdrop
      cancel-title="Cancel"
      cancel-variant="outline-secondary"
      ok-title="Post"
      centered
      size="lg"
      title="Signatory Mandate"
      :ok-disabled="hasSelectedSignatory"
      @ok="handleSubmit"
    >
      <b-tabs>
        <b-tab
          title="Account Signatories"
          active
        >
          <b-table
            ref="signatoryTable"
            select-mode="single"
            :items="signatoryList"
            responsive
            no-local-sorting
            :fields="signatoryListHeader"
            primary-key="id"
            show-empty
            empty-text="No result found"
            class="position-relative mt-2"
          >
            <template #cell(SN)="data">
              {{ getOverallIndex(data.index) }}
            </template>

            <template #cell(select)="data">

              <b-form-group class="mt-1">
                <b-form-checkbox
                  v-model="data.item.select"
                  @change="onSelect"
                />
              </b-form-group>
            </template>

            <template #cell(passport)="data">
              <b-media vertical-align="center">
                <template #aside>
                  <b-avatar
                    size="32"
                    :src="data.item.passport"
                    button
                    @click="onViewPassport(data.item.passport, data.item.fullName)"
                  />
                </template>
              </b-media>
            </template>

            <template #cell(signature)="data">
              <b-media vertical-align="center">
                <template #aside>
                  <b-avatar
                    size="32"
                    :src="data.item.signature"
                    button
                    @click="onViewSignature(data.item.signature, data.item.fullName)"
                  />
                </template>
              </b-media>
            </template>
          </b-table>

        </b-tab>

        <b-tab
          title="Mandate Information"
        >
          <b-table
            ref="mandateListTable"
            select-mode="single"
            :items="mandateList"
            responsive
            :fields="mandateListHeaders"
            primary-key="id"
            selectable
            show-empty
            empty-text="No data available"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative"
          >
            <template #cell(SN)="data">
              {{ getOverallIndex(data.index) }}
            </template>
            <template #cell(isLimited)="data">
              {{ data.value === false ? 'Unlimited' : 'Limited' }}
            </template>
            <template #cell(amount)="data">
              {{ data.value === 0 ? 'Unlimited' : toAmount(data.value) }}
            </template>
          </b-table>

        </b-tab>
      </b-tabs>

    </b-modal>

    <b-modal
      id="avatar-modal"
      ref="avatarModal"
      cancel-title="Cancel"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="avatarModalTitle"
      @hidden="resetAvatarModal"
      @cancel="resetAvatarModal"
    >

      <div class="m-2 text-center">
        <b-row>
          <b-col
            cols="12"
          >
            <b-img
              v-if="avatarLg"
              :src="avatarLg"
              :alt="avatarModalTitle"
              fluid
            />
            <b-avatar
              v-else
              size="30rem"
              :src="avatarLg"
            />
          </b-col>
        </b-row>
      </div>

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <b-modal
      id="memo-info-modal"
      ref="memoInfoModal"
      ok-title="Cancel"
      ok-only
      title="Memo"
      ok-variant="outline-secondary"
      centered
      no-close-on-backdrop
      size="lg"
    >
      <b-table
        ref="memoListTable"
        select-mode="single"
        :items="memoGetData"
        responsive
        :fields="memoListHeaders"
        primary-key="id"
        selectable
        show-empty
        empty-text="No data available"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
      >
        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>
      </b-table>
    </b-modal>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>

import {
  BCard, BRow, BCol, BTable, BMedia, BAvatar, BFormGroup, BFormCheckbox, BTabs, BTab, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { tableMixins } from '@core/mixins/table'
import { modalMixins } from '@core/mixins/modal'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { postingPermissions } from '@/helpers/permissions'
import getSelectedSignatory from '@/helpers/getSelectedSignatory'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toBalance, toKobo, toAmount } from '@/helpers/formatAmount'
import TablePagination from '@/views/components/table/TablePagination.vue'
import InputField from '../../../../forms/InputField.vue'
import Alert from '../../../../components/alert/Alert.vue'
import Button from '../../../../components/button/Button.vue'
import { transformMandateRule } from '@/helpers/transformers'
import InputNumberField from '../../../../forms/InputNumberField.vue'

const today = new Date()
const dateTime = moment(today).format()

export default {
  components: {
    BRow,
    BCol,
    BMedia,
    BAvatar,
    InputField,
    BTabs,
    BTab,
    BImg,
    Alert,
    Button,
    BTable,
    BCard,
    ValidationObserver,
    BFormGroup,
    BFormCheckbox,
    // TableEntries,
    TablePagination,
    FullScreenSpinner,
    AppCollapse,
    AppCollapseItem,
    InputNumberField,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [sweetAlert, tableMixins, modalMixins],
  data() {
    return {
      showFormErrorAlert: false,
      showCustomerInfo: false,
      showSearchButton: false,
      showBackButton: false,
      isEditable: true,
      isLoading: false,
      isDisabled: false,
      customerList: [],
      required,
      positive,
      showSpinner: false,
      sortDesc: false,
      currentPage: 1,
      selected: [],
      signatoryList: [],
      signatoryMandateList: [],
      selectedSignatories: [],
      mandateList: [],
      tillAccountNumber: '',
      tillAccountName: '',
      toAmount,
      toBalance,
      perPage: 10,
      avatarLg: '',
      avatarModalTitle: '',
      sortBy: 'accountName',
      filteredResult: [],
      searchParams: {
        accountNumber: null,
        accountName: null,
        referenceNumber: null,
      },
      depositData: {
        accountNumber: '',
        accountName: '',
        amount: '',
        recordType: 'Credit',
        narration: '',
        instrumentNumber: '',
        entryCode: 'C101',
        branchCode: '',
      },
      postingFormData: {
        postingData: {
          realDate: dateTime,
          postingType: 'CashWithdrawalPosting',
          senderName: '',
          initiatedBy: '',
        },
      },
      posting: [],
      customer: {
        accountName: '',
        accountNumber: '',
        productName: '',
        branchName: '',
        accountStatus: '',
        ledgerBalance: '',
        availableBalance: '',
        withdrawableBalance: '',
        overdraftLimit: '',
        accountOfficer: '',
        accountTierLevel: '',
        minimumBalanceRequired: null,
        accountCreationChannel: null,
      },
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true },
        { key: 'accountName', sortable: true },
        { key: 'accountNumber', sortable: true },
      ],
      mandateListHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'rule', sortable: true },
        { key: 'isLimited', sortable: true, label: 'limit' },
        { key: 'amount', sortable: true },
      ],
      signatoryListHeader: [
        { key: 'SN', label: 'S/N' },
        { key: 'select' },
        { key: 'fullName', sortable: true },
        { key: 'category', sortable: true },
        { key: 'passport', sortable: true },
        { key: 'signature', sortable: true },
      ],
      memoListHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountNumber' },
        { key: 'actionType' },
        { key: 'details', label: 'Reason' },
        { key: 'comments' },
        { key: 'initiatedBy' },
      ],
      memoGetData: [],
    }
  },
  computed: {
    ...mapGetters({
      userData: 'auth/getCurrentUser',
      tillAccounts: 'operations/getTillAccount',
    }),
    hasSelectedSignatory() {
      return !this.selectedSignatories.length
    },
  },
  methods: {
    ...mapActions({
      searchCustomerAccount: 'account/searchCustomerAccountAction',
      postCashDeposit: 'posting/postingAction',
      getUserBalance: 'account/getCASABalanceAction',
      getAccountSignatories: 'account/getAccountSignatoriesAction',
      getByAccountNumber: 'account/getByAccountNumber',
      getTillAccountList: 'operations/getTillAccountList',
    }),
    onSelect(value) {
      if (value) {
        this.selectedSignatories.push(value)
      } else {
        this.selectedSignatories.pop()
      }
    },
    async handleSearch() {
      try {
        const isSearchParamsNotEmpty = Object.values(this.searchParams).every(params => (params === null || params === ''))
        if (!isSearchParamsNotEmpty) {
          this.showFormErrorAlert = false
          this.showSpinner = true
          const response = await this.searchCustomerAccount({
            search: this.searchParams,
            page: this.currentPage,
            limit: this.perPage,
            permission: postingPermissions.CASH_WITHDRAWAL_POSTING,
          })
          const { status, data } = response
          if (status === 200 && data?.data) {
            this.customerList = data.data
            this.totalCount = data.recordCount
            this.$root.$emit('bv::show::modal', 'search-modal')
          } else {
            this.customerList = []
            this.totalCount = data.recordCount
            this.$root.$emit('bv::show::modal', 'search-modal')
          }
        } else {
          this.showFormErrorAlert = true
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    // eslint-disable-next-line consistent-return
    async getTillUserAccount() {
      try {
        const response = await this.getTillAccountList({
          search: {
            tellerUserID: this.userData.id,
          },
          permission: postingPermissions.CASH_WITHDRAWAL_POSTING,
        })
        const { data, status } = response

        if (data.data !== null && status === 200) {
          this.tillAccountNumber = data.data[0].accountNumber
          this.tillAccountName = data.data[0].accountName
          return true
        }
        if (data.data == null && status === 200) {
          this.alertError({ text: 'Till Account has not been configured for you' })
          return false
        }
      } catch (error) {
        this.handleError(error)
      }
    },
    async onSelectCustomer(items) {
      try {
        const [customer] = items
        this.hideModal('search-modal')
        this.showSpinner = true
        const response = await this.getUserBalance({ accountNumber: customer?.accountNumber, permission: postingPermissions.CASH_WITHDRAWAL_POSTING })
        const { data, status } = response
        if (status === 200) {
          this.customer = {
            ...customer,
            availableBalance: toBalance(data.availableBalance),
            withdrawableBalance: toBalance(data.withdrawableBalance),
            overdraftLimit: toBalance(data.overdraftLimit),
            ledgerBalance: toBalance(data.ledgerBalance),
            accountOfficer: data.accountOfficerName,
          }
          if (data.memos !== null) {
            this.memoGetData = data.memos
            this.$root.$emit('bv::show::modal', 'memo-info-modal')
          }
          this.depositData.accountNumber = customer?.accountNumber
          this.depositData.accountName = customer?.accountName
          this.depositData.branchCode = customer?.branchCode
          this.depositData.narration = `Cash Wdr with Instr.no ${this.depositData.instrumentNumber} by ${this.postingFormData.postingData.senderName}`
          this.showCustomerInfo = true
          this.showSearchButton = true
          this.showBackButton = true
          await this.fetchAccountSignatories({ accountNumber: data.accountNumber })
          const accountResponse = await this.getByAccountNumber({ accountNumber: data.accountNumber, permission: postingPermissions.CASH_WITHDRAWAL_POSTING })
          if (accountResponse.status === 200 && accountResponse.data.data) {
            this.mandateList = transformMandateRule(accountResponse.data.data.mandateRuleIndex)
          }

          // this.hideModal('search-modal')
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async fetchAccountSignatories({ accountNumber }) {
      try {
        const { status, data } = await this.getAccountSignatories({ accountNumber, permission: postingPermissions.CASH_WITHDRAWAL_POSTING })

        if (status === 200 && data.data) {
          this.signatoryList = data.data.map(item => ({
            fullName: item.name,
            passport: item.passportFileUrl,
            signature: item.signatureFileUrl,
            category: item.category,
            select: false,
          }))
        } else {
          this.signatoryList = []
          this.signatoryMandateList = []
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    onViewSignatoryMandate() {
      this.$refs.cashWithdrawalRules.validate().then(success => {
        if (success) {
          this.$root.$emit('bv::show::modal', 'signatory-mandate-table')
        }
      })
    },
    onViewPassport(image, name) {
      this.avatarLg = image
      this.avatarModalTitle = `${name}'s Passport`
      this.$root.$emit('bv::show::modal', 'avatar-modal')
    },
    onViewSignature(image, name) {
      this.avatarLg = image
      this.avatarModalTitle = `${name}'s Signature`
      this.$root.$emit('bv::show::modal', 'avatar-modal')
    },
    async handleSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.confirm(this.cashWithdrawalAction, { text: 'Are you sure you want to make cash withdrawal?' })
    },
    async cashWithdrawalAction() {
      try {
        this.postingFormData.postingData.initiatedBy = this.userData.email
        const hasTillAccountConfigured = await this.getTillUserAccount()
        if (hasTillAccountConfigured) {
          this.showSpinner = true
          const postingApprovalModel = {
            amount: Number(toKobo(this.depositData.amount).toFixed()),
            accountName: this.customer.accountName,
            initiatedBy: '',
            approvedBy: '',
            postingType: 'CashWithdrawalPosting',
          }
          this.postingFormData.postingApprovalModel = postingApprovalModel
          this.postingFormData.postingData.initiatedBy = this.userData.email
          this.postingFormData.postingEntry = [
            {
              accountNumber: this.depositData.accountNumber,
              accountName: this.depositData.accountName,
              amount: Number(toKobo(this.depositData.amount).toFixed()),
              recordType: 'Debit',
              narration: this.depositData.narration,
              instrumentNumber: this.depositData.instrumentNumber,
              entryCode: 'D-CSHW',
              branchCode: this.depositData.branchCode,
            },
            {
              accountNumber: this.tillAccountNumber,
              accountName: this.tillAccountName,
              amount: Number(toKobo(this.depositData.amount).toFixed()),
              recordType: 'Credit',
              narration: this.depositData.narration,
              instrumentNumber: this.depositData.instrumentNumber,
              entryCode: 'C-CSHW',
              branchCode: this.userData.branchCode,
            },
          ]

          this.postingFormData.signedSignatories = getSelectedSignatory(this.signatoryList, 'category')
          this.hideModal('signatory-mandate-table')
          this.isLoading = true
          this.isDisabled = true
          const postingData = this.postingFormData
          const response = await this.postCashDeposit({ postingData, permission: postingPermissions.CASH_WITHDRAWAL_POSTING })
          const { status, data } = await response
          if (status === 200 && data.isSuccessful) {
            this.showCustomerInfo = false
            this.resetInputField()
            this.resetSearchParams()
            this.alertSuccess({ text: `Your Cash withdrawal request was successful. Cash withdrawal reference ID is ${data.referenceNumber}` })
            this.$router.push('cash-withdrawal-list')
          }
          if (status === 200 && !data.isSuccessful) {
            this.alertError({ text: `Your Cash withdrawal request failed. Reason: ${data.message}` })
          }
        } else {
          this.alertError({ text: 'You do not have a configured Till Account. Please contact your Administrator' })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
        this.showSpinner = false
      }
    },
    setPayeeNarration(val) {
      this.postingFormData.postingData.senderName = val
      this.depositData.narration = `Cash Wdr with Instr.no ${this.depositData.instrumentNumber} by ${this.postingFormData.postingData.senderName}`
    },
    setInstrumentNoNarration(val) {
      this.depositData.instrumentNumber = val
      this.depositData.narration = `Cash Wdr with Instr.no ${this.depositData.instrumentNumber} by ${this.postingFormData.postingData.senderName}`
    },
    resetInputField() {
      this.searchParams = { ...null }
      this.depositData = { ...null }
      this.customer = { ...null }
      this.isLoading = false
      this.isDisabled = false
      this.showCustomerInfo = false
      this.showSearchButton = false
      this.showBackButton = false
    },
    showSearchField() {
      this.showSearchButton = false
      this.resetSearchParams()
    },
    resetSearchParams() {
      this.searchParams.accountNumber = null
      this.searchParams.accountName = null
      this.searchParams.referenceNumber = null
    },
    resetAvatarModal() {
      this.avatarLg = ''
      this.avatarModalTitle = ''
    },
    resetModal() {
      this.customerList = []
    },
    backNavigationAction() {
      this.$router.push({
        name: 'cash-withdrawal-list',
      })
    },

  },
}
</script>
<style scoped>
 [dir] .demo-inline-spacing > *, .custom-control , .custom-control-inline, .custom-checkbox {
    margin-top: 0rem !important;
  }
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem
}
</style>
